import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { CSVLink } from 'react-csv';

class DownloadCSV extends React.Component {
    constructor(props) {
        super(props);
        this.CSVLink = React.createRef();
        this.submit = this.submit.bind(this);
        this.state = {
            data: []
        }
    }

    submit = async () => {
        let params = { scopes: ["user.read"], account: this.props.instance.getAllAccounts()[0] };
        console.log(process.env);
        this.props.instance.acquireTokenSilent(params).then(response => {
            let id_token = response.idToken;
            fetch('./api/reports', {
                headers: new Headers({
                    'Authorization': 'Bearer ' + id_token,
                    'Content-Type': 'application/json'
                })
            }).then(response => response.json()).then(response => {
                this.setState({ data: response });
            }).then(() => {
                this.CSVLink.current.link.click();
            });
        });
    }

    render() {
        return (
            <div>
                <Button onClick={this.submit}>Download Report</Button>
                <CSVLink data={this.state.data} filename='newreport.csv' className='hidden' ref={this.CSVLink} target='_blank' />
            </div>
        );
    }
}
    
export default DownloadCSV;